import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EmptyStateIllustration = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "615",
        height: "418",
        viewBox: "0 0 615 418",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                opacity: "0.7",
                clipPath: "url(#clip0_1751_86898)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        opacity: "0.14",
                        d: "M378.5 419C492.547 419 585 326.547 585 212.5C585 98.4532 492.547 6 378.5 6C264.453 6 172 98.4532 172 212.5C172 326.547 264.453 419 378.5 419Z",
                        fill: "url(#paint0_radial_1751_86898)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        opacity: "0.4",
                        d: "M283.5 384C384.292 384 466 302.292 466 201.5C466 100.708 384.292 19 283.5 19C182.708 19 101 100.708 101 201.5C101 302.292 182.708 384 283.5 384Z",
                        fill: "url(#paint1_radial_1751_86898)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("g", {
                filter: "url(#filter0_dd_1751_86898)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M473 157L339.243 120.833C335.207 119.322 329.499 120.476 327.135 122.826L195.18 254.5C194.722 254.957 194.105 255.189 193.767 255.804C192.55 258.017 196.588 264.471 199.456 265.24L336.862 302.058C340.091 302.923 344.625 301.72 346.989 299.37L477.5 169C481 164.5 476.229 157.865 473 157Z",
                    fill: "url(#paint2_linear_1751_86898)"
                })
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M472.089 156.403L335.893 119.909C332.692 119.051 328.198 120.256 325.855 122.599L195.04 253.414C192.697 255.757 193.392 258.351 196.593 259.209L330.857 295.185C335.125 296.329 341.117 294.723 344.241 291.599L473.642 162.198C475.985 159.855 475.29 157.26 472.089 156.403Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("g", {
                filter: "url(#filter1_f_1751_86898)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M345.212 294.187L474.128 162.942C476.313 160.717 475.782 158.261 472.91 157.303L464.5 154.5L336.876 120.878C333.679 120.036 329.212 121.237 326.874 123.568L195.706 254.309C193.376 256.631 194.031 259.21 197.175 260.091L331.668 297.803C335.964 299.008 342.08 297.375 345.212 294.187Z",
                    fill: "url(#paint3_linear_1751_86898)"
                })
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M472.089 156.403L335.893 119.909C332.692 119.051 328.198 120.256 325.855 122.599L195.04 253.414C192.697 255.757 193.392 258.351 196.593 259.209L330.857 295.185C335.125 296.329 341.117 294.723 344.241 291.599L473.642 162.198C475.985 159.855 475.29 157.26 472.089 156.403Z",
                fill: "url(#paint4_linear_1751_86898)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M341.65 154.975C341.487 154.521 340.662 154.413 340.002 154.243L281.352 139.16C280.692 138.983 279.783 139.177 279.042 139.605C278.495 139.921 278.073 140.316 277.558 140.653L276.277 141.492C275.762 141.829 275.275 142.203 275.128 142.619C274.821 143.487 275.055 144.646 275.759 144.834L335.305 160.789C336.199 161.029 337.55 160.588 338.323 159.805L341.119 156.968C341.631 156.448 341.852 155.533 341.65 154.975Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M340.898 154.116L281.352 138.16C280.457 137.921 279.107 138.361 278.334 139.145L275.537 141.982C274.765 142.765 274.864 143.594 275.759 143.834L335.305 159.789C336.2 160.029 337.55 159.588 338.323 158.805L341.119 155.968C341.892 155.184 341.793 154.355 340.898 154.116Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M348.919 173.791C348.589 173.535 347.992 173.478 347.495 173.348L267.922 152.664C267.13 152.451 266.167 152.539 265.381 152.847C264.564 153.167 263.972 153.712 263.247 154.129L262.338 154.651C261.613 155.067 260.945 155.568 260.916 156.103C260.867 156.99 261.465 158.106 262.351 158.343L342.712 179.876C343.92 180.2 345.521 179.826 346.291 179.042L349.077 176.202C349.685 175.582 349.608 174.326 348.919 173.791Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M348.008 173.123L267.647 151.59C266.439 151.267 264.838 151.64 264.068 152.424L261.283 155.264C260.513 156.049 260.868 156.946 262.075 157.27L342.437 178.802C343.644 179.126 345.246 178.753 346.015 177.968L348.801 175.128C349.57 174.344 349.215 173.446 348.008 173.123Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M297.767 196.85C297.625 196.378 296.783 196.261 296.106 196.087L239.014 181.421C238.365 181.247 237.461 181.449 236.722 181.887C236.195 182.2 235.784 182.584 235.285 182.914L233.977 183.779C233.477 184.109 233.004 184.474 232.852 184.879C232.526 185.746 232.73 186.909 233.419 187.094L291.422 202.636C292.293 202.869 293.625 202.424 294.398 201.64L297.196 198.803C297.698 198.294 297.933 197.407 297.767 196.85Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M297.038 195.968L239.035 180.426C238.163 180.193 236.831 180.638 236.058 181.422L233.261 184.258C232.488 185.042 232.568 185.866 233.44 186.099L291.443 201.641C292.314 201.875 293.646 201.429 294.419 200.646L297.216 197.809C297.989 197.025 297.909 196.202 297.038 195.968Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M296.945 177.358C296.733 177.078 296.266 176.943 295.802 176.83L252.427 166.264C251.899 166.122 251.041 166.416 250.323 166.946C249.967 167.21 249.659 167.495 249.299 167.756L247.754 168.881C247.394 169.142 247.052 169.419 246.873 169.725C246.373 170.576 246.27 171.786 246.817 171.933L290.393 183.609C291.048 183.784 292.725 183.283 293.5 182.5L296.5 179.5C297.126 178.867 297.394 177.95 296.945 177.358Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M296.214 176.996L252.638 165.32C251.984 165.145 250.825 165.637 250.051 166.42L247.245 169.255C246.47 170.038 246.373 170.814 247.028 170.989L290.604 182.665C291.259 182.841 292.417 182.349 293.192 181.566L295.997 178.731C296.772 177.948 296.869 177.172 296.214 176.996Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M304.868 217.787C304.538 217.531 303.941 217.473 303.444 217.344L223.872 196.659C223.079 196.447 222.116 196.535 221.331 196.842C220.513 197.163 219.921 197.707 219.196 198.124L218.287 198.646C217.562 199.063 216.894 199.564 216.865 200.099C216.817 200.986 217.415 202.102 218.3 202.339L298.662 223.872C299.869 224.195 301.471 223.822 302.24 223.037L305.026 220.198C305.634 219.577 305.558 218.322 304.868 217.787Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M303.957 217.118L223.596 195.586C222.389 195.262 220.787 195.635 220.017 196.42L217.232 199.26C216.462 200.044 216.818 200.942 218.025 201.265L298.386 222.798C299.593 223.122 301.195 222.748 301.964 221.964L304.75 219.124C305.519 218.339 305.165 217.442 303.957 217.118Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M252.894 221.354C252.682 221.074 252.215 220.938 251.751 220.825L208.377 210.259C207.848 210.117 206.991 210.411 206.272 210.942C205.916 211.205 205.608 211.491 205.248 211.752L203.703 212.876C203.344 213.138 203.002 213.415 202.822 213.721C202.322 214.572 202.22 215.782 202.766 215.928L246.342 227.604C246.997 227.78 248.674 227.279 249.449 226.496L252.449 223.496C253.076 222.863 253.343 221.946 252.894 221.354Z",
                fill: "#4926CD"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M252.164 220.992L208.588 209.316C207.933 209.14 206.775 209.633 206 210.416L203.195 213.25C202.42 214.033 202.323 214.81 202.977 214.985L246.553 226.661C247.208 226.837 248.366 226.344 249.141 225.561L251.946 222.727C252.721 221.944 252.818 221.167 252.164 220.992Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M334.141 137.675C335.034 137.914 335.694 138.279 336.121 138.77C336.549 139.262 336.712 139.824 336.611 140.458C336.511 141.092 336.144 141.73 335.511 142.372C334.878 143.014 334.096 143.541 333.166 143.953C332.236 144.365 331.263 144.623 330.248 144.728C329.233 144.832 328.28 144.765 327.387 144.526L323.763 143.555L330.517 136.704L334.141 137.675ZM328.456 143.407C329.042 143.564 329.672 143.607 330.346 143.536C331.026 143.459 331.674 143.281 332.29 143.003C332.907 142.725 333.43 142.367 333.861 141.93C334.292 141.493 334.545 141.063 334.62 140.64C334.695 140.217 334.592 139.842 334.31 139.515C334.034 139.182 333.604 138.937 333.018 138.78L331.03 138.247L326.469 142.874L328.456 143.407ZM341.412 143.226L341.155 143.157C340.488 142.978 339.824 142.976 339.162 143.15C338.509 143.326 337.951 143.65 337.488 144.12L335.06 146.582L333.546 146.176L338.538 141.112L340.052 141.518L339.318 142.263C339.841 142.068 340.351 141.95 340.848 141.907C341.362 141.861 341.839 141.897 342.281 142.015L342.538 142.084L341.412 143.226ZM345.303 149.327L343.789 148.921L344.503 148.196C343.947 148.39 343.39 148.504 342.832 148.539C342.274 148.573 341.747 148.524 341.251 148.391C340.611 148.22 340.143 147.948 339.849 147.576C339.563 147.207 339.471 146.781 339.571 146.297C339.681 145.816 339.98 145.327 340.47 144.831C340.959 144.334 341.547 143.923 342.234 143.596C342.929 143.272 343.648 143.063 344.391 142.969C345.142 142.878 345.838 142.918 346.478 143.089C346.973 143.222 347.357 143.417 347.628 143.674C347.899 143.93 348.045 144.233 348.066 144.582L348.781 143.857L350.295 144.263L345.303 149.327ZM342.025 145.248C341.738 145.539 341.564 145.831 341.503 146.124C341.457 146.413 341.528 146.671 341.716 146.897C341.903 147.123 342.2 147.29 342.605 147.399C343.002 147.505 343.431 147.532 343.893 147.48C344.354 147.428 344.793 147.307 345.208 147.117C345.639 146.923 345.998 146.68 346.285 146.389C346.572 146.098 346.738 145.808 346.784 145.519C346.845 145.225 346.782 144.966 346.594 144.74C346.407 144.514 346.115 144.348 345.718 144.241C345.312 144.133 344.879 144.104 344.417 144.156C343.955 144.208 343.509 144.332 343.079 144.526C342.663 144.716 342.312 144.956 342.025 145.248ZM356.47 144.424C355.794 144.243 355.228 144.384 354.771 144.847L354.291 145.334L356.13 145.826L355.132 146.839L353.293 146.346L349.299 150.397L347.785 149.991L351.778 145.94L350.615 145.629L351.614 144.616L352.777 144.928L353.325 144.372C353.834 143.855 354.417 143.501 355.073 143.309C355.73 143.117 356.424 143.118 357.154 143.314C357.605 143.435 357.951 143.616 358.192 143.856L357.223 144.839C357.055 144.652 356.804 144.513 356.47 144.424ZM356.203 150.151C355.975 150.383 355.888 150.581 355.941 150.746C355.995 150.911 356.184 151.037 356.509 151.124C356.816 151.206 357.19 151.231 357.632 151.199L356.604 152.242C356.088 152.279 355.601 152.236 355.141 152.113C354.411 151.918 353.998 151.631 353.902 151.254C353.813 150.87 354.017 150.427 354.513 149.924L357.048 147.352L355.885 147.041L356.883 146.028L358.046 146.34L359.338 145.029L360.853 145.435L359.561 146.746L361.508 147.267L360.51 148.28L358.562 147.758L356.203 150.151ZM360.001 153.415C358.892 153.118 358.191 152.604 357.898 151.873L359.455 151.299C359.632 151.848 360.121 152.23 360.923 152.445C361.32 152.551 361.693 152.589 362.044 152.557C362.403 152.528 362.668 152.427 362.837 152.255C363.013 152.076 363.022 151.911 362.864 151.76C362.712 151.602 362.426 151.413 362.006 151.191C361.586 150.97 361.253 150.764 361.008 150.573C360.773 150.384 360.634 150.154 360.593 149.884C360.552 149.614 360.701 149.306 361.041 148.962C361.53 148.466 362.17 148.152 362.96 148.02C363.751 147.889 364.538 147.929 365.322 148.139C366.323 148.407 366.976 148.866 367.28 149.517L365.709 150.087C365.513 149.616 365.076 149.29 364.4 149.109C364.039 149.013 363.696 148.979 363.371 149.009C363.06 149.035 362.824 149.13 362.66 149.296C362.484 149.474 362.471 149.638 362.621 149.787C362.779 149.938 363.077 150.127 363.516 150.353C363.933 150.565 364.26 150.766 364.495 150.955C364.74 151.146 364.883 151.376 364.924 151.647C364.965 151.917 364.819 152.221 364.487 152.559C363.984 153.069 363.319 153.397 362.491 153.543C361.669 153.683 360.839 153.64 360.001 153.415Z",
                fill: "#282863"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter0_dd_1751_86898",
                        x: "173.545",
                        y: "90.1522",
                        width: "325.183",
                        height: "240.186",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "-10"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "10"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1751_86898"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "8"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "10"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow_1751_86898",
                                result: "effect2_dropShadow_1751_86898"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_1751_86898",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter1_f_1751_86898",
                        x: "193.311",
                        y: "119.609",
                        width: "283.161",
                        height: "179.591",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "0.5",
                                result: "effect1_foregroundBlur_1751_86898"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint0_radial_1751_86898",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(378.5 212.5) scale(206.5)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FF8FE6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF8FE6",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint1_radial_1751_86898",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(283.5 201.5) scale(182.5)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#8296FF",
                                stopOpacity: "0.6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#8296FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_1751_86898",
                        x1: "480.482",
                        y1: "153.144",
                        x2: "179.336",
                        y2: "79.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#8B98DE"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.200284",
                                stopColor: "#C1CBFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.303741",
                                stopColor: "#E9ECFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.310958",
                                stopColor: "#DDE2FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.333069",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.491969",
                                stopColor: "#CED6FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.857402",
                                stopColor: "#94A0E3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#DAE0FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("linearGradient", {
                        id: "paint3_linear_1751_86898",
                        x1: "479",
                        y1: "146",
                        x2: "-89.2969",
                        y2: "881.607",
                        gradientUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ _jsx("stop", {
                            stopColor: "white"
                        })
                    }),
                    /*#__PURE__*/ _jsx("linearGradient", {
                        id: "paint4_linear_1751_86898",
                        x1: "478",
                        y1: "145",
                        x2: "-90.2973",
                        y2: "880.607",
                        gradientUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ _jsx("stop", {
                            stopColor: "white"
                        })
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_1751_86898",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "615",
                            height: "418",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
